import { Role } from '../mappers/business/toBusinessModel';
import { BusinessRegistrationStatus } from '../mappers/users/toUserModel';
import { UserUI } from '../ui/users/types';

export const isAdmin = (role?: Role) => role === Role.APPROVED_ADMIN;

export const isSuperAdmin = (role?: Role) => role === Role.SUPER_ADMIN;

export const isDeclinedAdmin = (role?: Role) => role === Role.DECLINED_BUSINESS_ADMIN;

export const isSupport = (role?: Role) => role === Role.SUPPORT;

export const canRegisterBusiness = (status?: BusinessRegistrationStatus) =>
    status === BusinessRegistrationStatus.DECLINED ||
    status === BusinessRegistrationStatus.NOT_REGISTERED;

export const canNotRegisterBusiness = (status?: BusinessRegistrationStatus) =>
    status === BusinessRegistrationStatus.REGISTERED;

export const canEditBusiness = (businessId?: string, user?: UserUI) =>
    isSuperAdmin(user?.role) ||
    (isAdmin(user?.role) &&
        (businessId === user?.profile?.id || businessId === user?.profile?.publicId));

export const canSeeSupportChat = (businessId?: string, user?: UserUI) =>
    canEditBusiness(businessId, user) || isDeclinedAdmin();

export const isBusinessAdmin = (businessId?: string, user?: UserUI) =>
    (isAdmin(user?.role) && businessId === user?.profile?.id) ||
    isSuperAdmin(user?.role) ||
    isSupport(user?.role);

export const canEditBusinessPublicId = (role?: Role) => role === Role.SUPER_ADMIN;

export const canEditBusinessInstagramUrl = (role?: Role) => role === Role.SUPER_ADMIN;

export const canEditBusinessCategories = (role?: Role) => role === Role.SUPER_ADMIN;

export const hasAccessToPostStat = (businessId?: string, user?: UserUI) =>
    canEditBusiness(businessId, user) || isSupport(user?.role);

export const hasAccessToBusinessStat = (businessId?: string, user?: UserUI) =>
    canEditBusiness(businessId, user) || isSupport(user?.role);

export const canSaveOrUpdatePost = (businessId?: string, user?: UserUI) =>
    isBusinessAdmin(businessId, user);

export const canSavePostToDraft = (businessId?: string, user?: UserUI) =>
    isBusinessAdmin(businessId, user);

export const canViewBusinessAsAdmin = (businessId?: string, user?: UserUI) =>
    isSuperAdmin(user?.role) ||
    isSupport(user?.role) ||
    (isAdmin(user?.role) && businessId === user?.profile?.id);

export const canEditBusinessCaver = (businessId: string, user?: UserUI) =>
    canEditBusiness(businessId, user);

export const canEditBusinessAvatar = (businessId: string, user?: UserUI) =>
    canEditBusiness(businessId, user);

export const canSeeBusinessSettings = (businessId: string, user?: UserUI) =>
    canEditBusiness(businessId, user) || isSupport(user?.role);

export const hasAccessToFeedManagement = (businessId: string, user?: UserUI) =>
    businessId &&
    user &&
    (user.profile?.publicId === businessId || isSuperAdmin(user.role) || isSupport(user.role));
